import { ReviewPlan } from './ReviewPlan';

export default ReviewPlan;